import { render, staticRenderFns } from "./Acceso.vue?vue&type=template&id=6fdcefe8&scoped=true&"
import script from "./Acceso.vue?vue&type=script&lang=js&"
export * from "./Acceso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdcefe8",
  null
  
)

export default component.exports